export default __webpack_public_path__ + "static/media/(37).5f216e47.jpg";